import { type MockMode } from "@/services/mockConfig";
import { handleEnvVars } from "./constants.config";
import { getConfig } from "@/services/config.ts";

let cachedEnvVars: ReturnType<typeof handleEnvVars> | null = null;

function getEnvVars() {
  if (!cachedEnvVars) {
    cachedEnvVars = handleEnvVars(getConfig());
  }
  return cachedEnvVars;
}

export function getMockMode(): MockMode {
  return (getConfig().VITE_MOCK_MODE as MockMode) ?? undefined;
}

export function getDevBaseUrl(): string {
  const { devApiBaseUrl, isProxied } = getEnvVars();
  return isProxied ? "" : devApiBaseUrl;
}

export function getCustomerBaseUrl(): string {
  return (
    getConfig().VITE_CUSTOMER_API_BASE_URL ?? `${getDevBaseUrl()}/customer`
  );
}

export function getKioskBaseUrl(): string {
  return getConfig().VITE_KIOSK_API_BASE_URL ?? `${getDevBaseUrl()}/customer`;
}

export function getPolicyBaseUrl(): string {
  return getConfig().VITE_POLICY_API_BASE_URL ?? `${getDevBaseUrl()}/customer`;
}

export function useDevToken(): string {
  return getConfig().VITE_USE_DEV_TOKEN;
}

export function hasGuard(): boolean {
  return useDevToken() !== "true" && getMockMode() !== "full";
}
